import Image from "next/image";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import { collectionList } from "@features/landing/helpers/constants/constants";

interface Props {
  disableShowMore?: boolean;
  className?: string;
}

const Collections: React.FC<Props> = ({
  disableShowMore = false,
  className,
}) => {
  return (
    <div className="w-full">
      <div className={twMerge("container-bs mb-[4.5rem] px-0", className)}>
        <span className="h5 mt-12 block mx-4 text-center font-semibold">
          مجموعه‌های آموزشی
        </span>
        <div className="w-full flex-wrap flex justify-center lg:mt-2">
          {collectionList.map((category, index) => (
            <Link
              aria-label={category.title}
              className="max-w-fds-120 w-1/3 xs:w-1/4  mxs:w-1/4 md:w-1/5 my-0 mxs:my-0 md:my-4 mx-0 mxs:mx-0 md:mx-[0.3rem] rounded-[3px] mxs:py-2.5 py-2.5 md:py-4 px-[0.2rem] flex flex-col  items-center transition-all duration-[125ms] ease-in-out border border-transparent hover:bg-[#f8f9fa] hover:border-[#cccccc]"
              href={category.url}
              prefetch={false}
              key={index}
            >
              <div className=" w-12 h-12 relative">
                <Image src={category.image} alt={category.title} fill />
              </div>
              <h2 className="text-center mt-5 mb-2 text-[0.95rem] leading-6 font-light text-[#202325]">
                {category.title}
              </h2>
            </Link>
          ))}
        </div>
        {!disableShowMore ? (
          <div className="text-center mt-4">
            <Link
              href="/explore"
              prefetch={false}
              className="btn btn-sm btn-primary ml-1 mr-1 py-3 text-sm"
            >
              همه آموزش‌ها
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Collections;
